import "./App.css";
import "react-slideshow-image/dist/styles.css";
import Header from "./components/Header";
import Home from "./routes/Home";
import ErrorPage from "./routes/error-page";
import { Route, Routes } from "react-router-dom";
import ShopGrid from "./routes/ShopGrid";
import Footer from "./components/Footer";
import ShopList from "./routes/ShopList";
import ShopLeftSidebar from "./routes/ShopLeftSidebar";
import ProductDetails from "./routes/ProductDetails";
import ShoppingCart from "./routes/ShoppingCart";
import Completed from "./routes/Completed";
import Demo from "./routes/Demo";
import MyAccount from "./routes/MyAccount";
import About from "./routes/About";
import Contact from "./routes/Contact";
import BlogPage from "./routes/BlogPage";
import Blog from "./components/Blog";
import BlogList from "./components/BlogList";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} errorElement={<ErrorPage />} />
        <Route path="shopgrid" element={<ShopGrid />} />
        <Route path="shoplist" element={<ShopList />} />
        <Route path="shopsidebar" element={<ShopLeftSidebar />} />
        <Route path="product/:productId" element={<ProductDetails />} />
        <Route path="shoppingcart" element={<ShoppingCart />} />
        <Route path="completed" element={<Completed />} />
        <Route path="demo" element={<Demo />} />
        <Route path="blog" element={<BlogPage />}>
          <Route path="" element={<BlogList />} />
          <Route path=":blogId" element={<Blog />} />
        </Route>
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="login" element={<MyAccount />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
